import React, { Component } from "react";
import facebookLogo from "../assets/images/facebook-das.png";
import twitterLogo from "../assets/images/twitter-das.png";

export default class Footer extends Component {
  render() {
    return (
      <div className="footer-container">
        <a href="https://www.facebook.com/DigitalAirStrike/">
          <img
            src={facebookLogo}
            alt="DAS Facebook Page"
            className="footer-social-icon"
          ></img>
        </a>
        <a href="https://twitter.com/DigitalAirStrk">
          <img
            src={twitterLogo}
            alt="DAS Twitter Page"
            className="footer-social-icon"
          ></img>
        </a>
      </div>
    );
  }
}
